const returnLoadSettings = (loadsToShow, columnsPerGroup, fontSize, isInline, type) => {
    let moreThan4 = false
    let funjumpClass = 'funjumptype'
    let showDotMenu = ''
    let setPos = ''
    let styledObject = {}

    if (window.innerWidth > 1600 && loadsToShow > 3) {
        moreThan4 = true
    }
    return {
        settingsMoreThan4: moreThan4,
        settingsFunjumpClass: funjumpClass,
        settingsShowDotMenu: showDotMenu,
        settingsSetPos: setPos,
        settingsStyledObject: styledObject
    }
}

export default returnLoadSettings
